module.exports = new __parcel__URL__("ai-chat-loading-promoted-darkmode.f2ea2011.svg").toString();